
import React from 'react';
import QuickChargeDialog from './QuickChargeDialog';
import { useQuickChargeStore } from '@/hooks/useQuickCharge';

export const QuickChargeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isOpen, familyId, familyName, closeDialog } = useQuickChargeStore();
  
  return (
    <>
      {children}
      {isOpen && familyId && (
        <QuickChargeDialog
          isOpen={isOpen}
          onClose={closeDialog}
          familyId={familyId}
          familyName={familyName || undefined}
        />
      )}
    </>
  );
};

export default QuickChargeProvider;
